import { DEFAULT_RATE_LIMIT_UNIT, UNLIMITED_RATE_LIMIT_THRESHOLD, } from '../../constants';
import { convertRateLimitFloat, rateLimitToValueAndUnit, } from './convertRateLimitUnits';
const UNLIMITED_VALUE = 'unlimited';
const parseRateLimitValue = (value) => {
    const numericValue = Number(value);
    const isUnlimited = Number.isNaN(numericValue) ||
        value === UNLIMITED_VALUE ||
        numericValue > UNLIMITED_RATE_LIMIT_THRESHOLD;
    if (isUnlimited) {
        return {
            isUnlimited: true,
            unit: DEFAULT_RATE_LIMIT_UNIT,
            value: Number.POSITIVE_INFINITY,
        };
    }
    const { unit, value: calculatedValue } = convertRateLimitFloat(rateLimitToValueAndUnit(numericValue));
    return {
        isUnlimited: false,
        unit,
        value: calculatedValue,
    };
};
export const parseRateLimitData = (data) => {
    const { default: defaultValue, isDefault, value } = data;
    const { isUnlimited, unit: initialUnitValue, value: initialNumberValue, } = parseRateLimitValue(value);
    const { isUnlimited: isDefaultUnlimited, unit: defaultUnitValue, value: defaultNumberValue, } = parseRateLimitValue(defaultValue);
    return {
        initialNumberValue,
        initialUnitValue,
        defaultNumberValue,
        defaultUnitValue,
        isUnlimited,
        isDefaultUnlimited,
        isDefault,
    };
};
